import { useState, useEffect } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
// import { useTheme } from '@mui/material/styles';
import getTheme from '../theme/theme';

import AboutButtons from './HeroButtons';
import Spacer from './Spacer';
import { ThemeProvider } from '@mui/material';
import { BASEURL } from "../constants/Common"

interface AboutProps {
  title: number;
  description: string;
}

const About = (): JSX.Element => {
  const theme = getTheme();

  const [about, setabout] = useState<AboutProps[]>([]);

  const fetchAbout = () => {
    const url = BASEURL + '/hero/';
    axios
      .get<AboutProps[]>(url, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setabout(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchAbout();
  }, []);

  return (
    <ThemeProvider theme={getTheme()}>
    <div id='home'>
      <Box
        sx={{
          py: 10,
          px: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        {about.slice(0, 1).map((item, i) => (
          <Container
            key={i}
            maxWidth='md'
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box marginBottom={2}>
              <Typography
                align='center'
                color={theme.palette.text.primary}
                variant='h3'
                sx={{ fontWeight: 700, textTransform: 'uppercase' }}
                gutterBottom
              >
                {item.title}
              </Typography>
            </Box>
            <Box marginBottom={3}>
              <Typography
                variant='h6'
                component='p'
                color={theme.palette.text.primary}
                sx={{ fontWeight: 400 }}
              >
                {item.description}
              </Typography>
            </Box>
            {/* <HeroButtons /> */}
          </Container>
        ))}
      </Box>
      <Spacer sx={{ pt: 6 }} />
    </div>

 </ThemeProvider>
  );
};

export default About;
